import React, { Fragment, useEffect, useState } from 'react';
import { ReactComponent as PostDetailsIcon } from 'assets/icons/post-details.svg';
import { ReactComponent as PostTimelineIcon } from 'assets/icons/post-timeline.svg';
import { Outlet, useNavigate } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import BottomNavigation from 'components/bottom-navigation';
import useCreatePostContext from 'contexts/create-post.context';
import moment from 'moment';
import { handleApiError } from 'utils/functions';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';

const CreatePostContent = () => {
  const [loading, setLoading] = useState(false);
  const { disabled, createPostForm, image } = useCreatePostContext();
  const navigate = useNavigate();
  const PostDetailsNav = [
    {
      title: 'Post details',
      link: `${ROUTE_KEYS.CREATE_POST}/${ROUTE_KEYS.CREATE_POST_DETAILS}`,
      Icon: PostDetailsIcon
    },
    {
      title: 'Post timeline',
      link: `${ROUTE_KEYS.CREATE_POST}/${ROUTE_KEYS.CREATE_POST_TIMELINE}`,
      Icon: PostTimelineIcon
    }
  ];
  const { setRightSection } = useDashboardContext();
  useEffect(() => {
    setRightSection(<RightSidebar title='Post Information' list={PostDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        heading: createPostForm.heading,
        title: createPostForm.title,
        cokitchen_ids: createPostForm.cokitchen_ids,
        polygon_ids: createPostForm.location,
        item_type: 'FOOD',
        body: createPostForm.body,
        images: [image],
        ...(createPostForm.meal_id && {
          meal_id: createPostForm.meal_id
        }),
        ...(createPostForm.brand_id && {
          brand_id: createPostForm.brand_id
        }),
        to_start_date: moment(createPostForm.start_date).format('YYYY-MM-DD'),
        to_start_time: `${createPostForm?.start_time?.timeWithColon}:00`,
        ...(createPostForm.end_date && {
          to_expire_date: moment(createPostForm.end_date).format('YYYY-MM-DD')
        }),
        ...(createPostForm?.end_time?.timeWithColon && {
          to_expire_time: `${createPostForm.end_time.timeWithColon}:00`
        }),
        post_type: createPostForm.post_type
      };
      const res = await apiService.post('marketing/posts', {
        data: payload,
        isInternal: true
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(ROUTE_KEYS.HOME);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Outlet />
      <div className='mx-10 pb-8 max-w-[700px]'>
        <BottomNavigation
          loading={loading}
          list={PostDetailsNav}
          onConfirm={handleConfirm}
          disabled={disabled}
        />
      </div>
    </Fragment>
  );
};

export default CreatePostContent;
